var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#00A86B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0393 31.3198C18.4903 25.5599 29.5101 25.5599 31.9621 31.3198C32.1001 31.6458 31.8481 31.9998 31.4851 31.9998H16.5153C16.1523 31.9998 15.9003 31.6458 16.0393 31.3198ZM24.0002 16C21.2392 16 19.0003 18.239 19.0003 20.9999C19.0003 23.7609 21.2392 25.9999 24.0002 25.9999C26.7612 25.9999 29.0001 23.7609 29.0001 20.9999C29.0001 18.239 26.7612 16 24.0002 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4998 23.5C34.4998 24.8809 33.3809 25.9999 31.9999 25.9999C30.6189 25.9999 29.4999 24.8809 29.4999 23.5C29.4999 22.119 30.6189 21 31.9999 21C33.3809 21 34.4998 22.119 34.4998 23.5ZM16.0001 21C14.6191 21 13.5001 22.119 13.5001 23.5C13.5001 24.8809 14.6191 25.9999 16.0001 25.9999C17.3811 25.9999 18.5001 24.8809 18.5001 23.5C18.5001 22.119 17.3811 21 16.0001 21ZM35.9808 28.6599C35.0118 26.3839 31.3739 25.9139 29.2829 27.2359C30.1879 27.7079 30.9799 28.2989 31.6199 28.9999H35.7428C35.9238 28.9999 36.0498 28.8229 35.9808 28.6599ZM18.7171 27.2359C16.6261 25.9139 12.9882 26.3839 12.0192 28.6599C11.9502 28.8229 12.0762 28.9999 12.2582 28.9999H16.3811C17.0201 28.2989 17.8121 27.7079 18.7171 27.2359Z",
    fill: "#F7F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.60e3c68e80c40a894d8fe95edba0b069.svg";
export { ForwardRef as ReactComponent };